import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "inner" }
const _hoisted_2 = { class: "options" }
const _hoisted_3 = { class: "switch-subtitle" }
const _hoisted_4 = { class: "switch-subtitle" }
const _hoisted_5 = { class: "tags-pane" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = {
  key: 0,
  class: "progress-bar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!
  const _component_EditTags = _resolveComponent("EditTags")!
  const _component_NcProgressBar = _resolveComponent("NcProgressBar")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_AlbumPicker = _resolveComponent("AlbumPicker")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        ref: "modal",
        onClose: _ctx.cleanup,
        size: "normal",
        "can-close": _ctx.pane === 0
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.n('memories', 'Upload {n} file', 'Upload {n} files', _ctx.fileCount, { n: _ctx.fileCount })), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.pane === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_NcTextField, {
                      label: _ctx.t('memories', 'Destination path'),
                      "label-visible": true,
                      modelValue: _ctx.uploadPath,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploadPath) = $event)),
                      onClick: _ctx.chooseUploadPath,
                      readonly: ""
                    }, null, 8, ["label", "modelValue", "onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_2, [
                    (_ctx.config.albums_enabled)
                      ? (_openBlock(), _createBlock(_component_NcCheckboxRadioSwitch, {
                          key: 0,
                          "model-value": _ctx.albums.length > 0,
                          disabled: _ctx.processing,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pane = 1))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('memories', 'Add to albums')) + " ", 1),
                            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.albumNames), 1)
                          ]),
                          _: 1
                        }, 8, ["model-value", "disabled"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_NcCheckboxRadioSwitch, {
                      modelValue: _ctx.tagsShown,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tagsShown) = $event)),
                      disabled: _ctx.processing
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Add tags')) + " ", 1),
                        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t('memories', 'Attach collaborative tags to all uploads')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"]),
                    _createElementVNode("div", _hoisted_5, [
                      (_ctx.tagsShown)
                        ? (_openBlock(), _createBlock(_component_EditTags, {
                            key: 0,
                            ref: "tags",
                            photos: [],
                            disabled: _ctx.processing
                          }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.processing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createTextVNode(_toDisplayString(_ctx.progressNote) + " ", 1),
                          _createVNode(_component_NcProgressBar, {
                            value: _ctx.progress,
                            error: true
                          }, null, 8, ["value"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_NcButton, {
                      onClick: _ctx.upload,
                      variant: "primary",
                      disabled: _ctx.processing
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Upload')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ])
                ], 64))
              : (_ctx.pane === 1)
                ? (_openBlock(), _createBlock(_component_AlbumPicker, {
                    key: 1,
                    photos: [],
                    "initial-selection": _ctx.albums,
                    disabled: _ctx.processing,
                    onSelect: _ctx.selectAlbums
                  }, null, 8, ["initial-selection", "disabled", "onSelect"]))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onClose", "can-close"]))
    : _createCommentVNode("", true)
}